import { Component, OnInit, ViewChild, Output, EventEmitter} from '@angular/core';
@Component({
  selector: 'app-common-scheduler',
  templateUrl: './common-scheduler.component.html',
  styleUrls: ['../parts.css']
})
export class CommonSchedulerComponent implements OnInit {
  boardData: any = {}; // 面板数据
  boardGroupData: Array<any> = []; // 面板组数据
  boardPulseData: Array<any> = []; // 面板列表数据
  boardColumnData: Array<any> = []; // 面板表头数据
  // 定时
  schedulerConditionDisplayText = '定时'; // 定时默认文字
  schedulerConditionData: any; // 存放定时数据
  schedulerConditionVisible: boolean; // 定时pop是否关闭
  // 分组
  groupConditionVisible: boolean; // 分组POP是否关闭
  groupConditionId = null; // 分组选中ID
  groupConditionDisplayText = '分组'; // 条件二默认文字
  // 其他
  isVisible = false; // 弹窗显示控制
  isConfirmLoading = false; // 确定按钮
  recipeId = null; // 自动化模板ID
  relationId;
  instanceData: any = {}; // 存放实例返填数据
  taskIntegrationData: any = {}; // 存放任务数据
  categorieId: string; // 存放当前目录ID
  automation = {
    boardId: '',
    groupId: '',
    categoryId: '',
    relationId: '',
    schedulerDescription: '',
    schedulerConfig: {},
    conditions: [{}],
    pulseMapping: {}
  }; // 存放入参数据
  @ViewChild('pulseCard', { static: true }) pulseCard: any;
  @Output() nfDataChange: EventEmitter<any> = new EventEmitter<any>();
  constructor() { }

  ngOnInit() {
    if (this.boardData && JSON.stringify(this.boardData) !== '{}') {
      this.boardGroupData = this.boardData.boardData.groups ? this.boardData.boardData.groups : [];
      this.boardColumnData = this.boardData.boardData.columns ? this.boardData.boardData.columns : [];
      this.boardPulseData = this.boardData.boardData.pulses ? this.boardData.boardData.pulses : [];
    }
    // 带入菜单ID
    this.automation.categoryId = this.categorieId;
    this.automation.relationId = this.relationId;
    // 处理返填数据
    // 反填分组
    this.groupConditionId = JSON.stringify(this.instanceData) !== '{}' ? this.instanceData.config.groupId : '';
    this.boardGroupData.forEach((item, index) => {
      if (item.id === this.groupConditionId) {
        this.groupConditionDisplayText = item.title;
      }
    });
    if (JSON.stringify(this.instanceData) !== '{}') {
      // 反填定时
      this.schedulerConditionData = this.instanceData.config.schedulerConfig;
      this.schedulerConditionDisplayText =
        this.instanceData.config.schedulerDescription ? this.instanceData.config.schedulerDescription : '定时';
      if (this.instanceData.config) {
        // 触发发射事件
        this.automation = JSON.parse(JSON.stringify(this.instanceData.config));
        this.packageData(this.automation);
      }
    }
  }
  // 获取定时数据
  getSchedulerData(event) {
    this.schedulerConditionVisible = false;
    this.schedulerConditionDisplayText = event.text;
    this.schedulerConditionData = event.config;
    this.automation.schedulerDescription = this.schedulerConditionDisplayText;
    this.automation.schedulerConfig = this.schedulerConditionData;
    this.packageData(this.automation);
  }
  // 分组变更
  groupConditionChange(item) {
    this.groupConditionDisplayText = item.title;
    this.groupConditionId = item.id;
    this.automation.groupId = this.groupConditionId;
    this.groupConditionVisible = false;
    this.packageData(this.automation);
  }
  // 弹窗创建任务
  openTaskDialog() {
    this.isVisible = true;
  }
  // 弹窗确定事件
  handleOk() {
    this.pulseCard.onSubmit();
    this.isVisible = false;
  }
  // 弹窗关闭事件
  handleCancel() {
    this.isVisible = false;
  }
  // 获取任务创建数据
  getPulseCardData(event) {
    const data = event;
    const newObj = {};
    if (data && data.columnValues) {
      data.columnValues.forEach((item, index) => {
        newObj[item.columnId] = item.columnValue;
        this.automation.pulseMapping['columnValues'] = newObj;
      });
    }
    this.packageData(this.automation);
  }
  // 组件提交数据
  packageData(data) {
    if (data) {
      data.instanceDescription = this.schedulerConditionDisplayText + '在' + this.groupConditionDisplayText + '中，创建任务';
      this.nfDataChange.emit(data);
    }
  }

  // 获取当前提交状态，当所有必填项都填写时返回true
  getSubmitStatus(): boolean {
    return JSON.stringify(this.automation.schedulerConfig) !== '{}' &&
      this.groupConditionId &&
      JSON.stringify(this.automation.pulseMapping) !== '{}';
  }
}
